// removed by extract-text-webpack-plugin
module.exports = {"LoadProgress":"_28byiwNp8wLyM8KQMY52Xo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisLoadProgressSection.scss
// module id = 1203
// module chunks = 0